import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const TagWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 5,
}));

export const Icon = styled("div")(() => ({
  cursor: "pointer",
}));

export const ModelTextDescription = styled("span")(() => ({
  color: "#232325",
  fontSize: 16,
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: 0.5,
}));

export const NoDataContainer = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  width: "100%",
}));

export const NoDataTitle = styled("span")(() => ({
  fontSize: "16px",
  fontFamily: "Manrope",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "16px",
  textAlign: "center",
  color: colors.gray500,
}));

const styles = makeStyles(() => ({
  mainDiv: {
    padding: "0px",
  },
  iconDiv: {
    backgroundColor: "#FFFAEB",
  },
  content: {
    padding: "15px 32px",
  },
  containerLocation: {
    maxWidth: "150px",
  },
  scheduleButton: {
    whiteSpace: "nowrap",
  },
  button: {
    cursor: "pointer",
  },
  buttonDisabled: {
    cursor: "not-allowed",
  },
  itemTask: {
    textAlign: "left",
  },
  approveContent: {
    margin: "16px 0px",
  },
  approveDescription: {
    fontFamily: "Manrope",
    fontSize: "16px",
    lineHeight: "20px",
  },
  circleIcon: {
    cursor: "pointer",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "34px",
    height: "34px",
    background: "#EDF5FB",
    borderRadius: "50%",
    "& svg": {
      height: "100%",
    },
  },
  buttonEstimate: {
    color: "#3F6280",
    border: "1px solid #3F6280",
  },
  confirmModal: {
    width: 520,
  },
  loadingSendToAMOS: {
    color: "#475467 !important",
  },
  menuItemText: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#475467",
  },
  messageModal: {
    font: "400 16px/24px Inter",
  },
  subMessageModal: {
    color: "#f79009",
    font: "italic 400 16px/24px Inter",
  },
  subMessageVideoSurveyUnavailable: {
    color: "#308CDB",
    font: "italic 400 16px/24px Inter",
  },
  rescheduleModal: {
    width: "520px !important",
  },
}));

export default styles;
